//import { checkTokenExists, setToken } from '../helpers/auth';
import { imagePathToBase64 } from '@/helpers/image'
import api from './api';
import localforage from "localforage";

export const SET_SUBLOCATIONS = 'SET_SUBLOCATIONS';
export const ADD_SUBLOCATION = 'ADD_SUBLOCATION';
export const UPDATE_SUBLOCATION = 'UPDATE_SUBLOCATION';
export const REMOVE_SUBLOCATION = 'REMOVE_SUBLOCATION';

export const getSublocations = (location) => async dispatch => {
  if (window.navigator.onLine) {
      return window.axios.get(api.sublocations.index.replace(':location', location.id))
          .then(async (response) => {

              const sublocationPromises = (response.data.sublocations || []).map(async sublocation => {
                if(sublocation?.image_url) {
                  const { base64 } = await imagePathToBase64(sublocation.image_url);
                  sublocation.image_url = base64 ?? null;
                }
                return sublocation;
              });

              const sublocations = await Promise.all(sublocationPromises);

              dispatch(setSublocations(location, sublocations));

              return Promise.resolve({ sublocations: sublocations });
          })
          .catch(error => {
              return Promise.reject(error)
          });
  } else {
        try {
            await localforage.setDriver(localforage.INDEXEDDB);
            const sublocations = await localforage.getItem('bs_sublocations_' + location.id);
            if (sublocations) {
                dispatch(setSublocations(location, sublocations));
            }



            return Promise.resolve({ ...location.sublocations });
        } catch (e) {
            return Promise.reject(e);
        }

  }
};

export const createSublocation = (location, data) => dispatch => {
  return window.axios.post(api.sublocations.store.replace(':location', location.id), data)
        .then((response) => {
          dispatch(addSublocation(location, response.data.sublocation));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const editSublocation = (location, sublocation, data) => dispatch => {
  data['_method'] = 'PATCH';
  return window.axios.post(api.sublocations.update.replace(':sublocation', sublocation.id), data)
        .then((response) => {
          dispatch(updateSublocation(location, response.data.sublocation));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const deleteSublocation = (sublocation) => dispatch => {
  let data = {};
  data['_method'] = 'DELETE';
  return window.axios.post(api.sublocations.destroy.replace(':sublocation', sublocation.id), data)
        .then((response) => {
          dispatch(removeSublocation(location));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const setSublocations = (location, sublocations) => ({
  type: SET_SUBLOCATIONS,
  location, 
  sublocations
});

export const addSublocation = (location, sublocation) => ({
  type: ADD_SUBLOCATION,
  location,
  sublocation
});

export const updateSublocation = (location, sublocation) => ({
  type: UPDATE_SUBLOCATION,
  location,
  sublocation
});

export const removeSublocation = (sublocation) => ({
  type: REMOVE_SUBLOCATION,
  sublocation
});